<template>
  <div class="app">
    <AppHeader fixed>
      <SidebarToggler class="d-lg-none" display="md" mobile />
      <b-link class="navbar-brand" to="#">
        <img class="navbar-brand-full" src="img/logo.png" width="50" height="50" alt="Logo">
        <img class="navbar-brand-minimized" src="img/logo.png" width="50" height="50" alt="Logo">
      </b-link>
      <SidebarToggler class="d-md-down-none" display="lg" />
      <b-navbar-nav class="ml-auto">
        <DefaultHeaderDropdownAccnt />
      </b-navbar-nav>
    </AppHeader>
    <div class="app-body">
      <AppSidebar fixed>
        <SidebarHeader />
        <SidebarForm />
        <SidebarNav :navItems="nav"></SidebarNav>
        <SidebarFooter />
        <SidebarMinimizer />
      </AppSidebar>
      <main class="main">
        <div class="container-fluid">
          <router-view></router-view>
        </div>
      </main>
    </div>
    <spinner />
  </div>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<script>
  import {
    Header as AppHeader,
    SidebarToggler,
    Sidebar as AppSidebar,
    SidebarFooter,
    SidebarForm,
    SidebarHeader,
    SidebarMinimizer,
    SidebarNav,
  } from '@coreui/vue'
  import DefaultHeaderDropdownAccnt from './DefaultHeaderDropdownAccnt'
  import Spinner from "@/components/spinner"

  export default {
    name: 'DefaultContainer',
    components: {
      AppHeader,
      AppSidebar,
      DefaultHeaderDropdownAccnt,
      SidebarForm,
      SidebarFooter,
      SidebarToggler,
      SidebarHeader,
      SidebarNav,
      SidebarMinimizer,
      Spinner,
    },
    data() {
      return {
        nav: [],
      }
    },
    created() {
      const _ = this;
      _.getMenu();
    },
    methods: {
      getMenu() {
        let _ = this;
        let menus = localStorage.getItem('menus');
        menus = menus ? JSON.parse(menus) : [];
        _.nav = _.cleanObject(menus);
      },
      cleanObject(obj) {
        let _ = this;
        if (Array.isArray(obj)) {
          return obj.map(_.cleanObject).filter(item => item && Object.keys(item).length > 0);
        } else if (typeof obj === 'object' && obj !== null) {
          return Object.entries(obj).reduce((acc, [key, value]) => {
            if (value !== null && value !== undefined && value !== "" && 
                !(Array.isArray(value) && value.length === 0)) {
              acc[key] = _.cleanObject(value);
            }
            return acc;
          }, {});
        }
        return obj;
      }
    },
    computed: {
      name() {
        return this.$route.name
      },
      list() {
        return this.$route.matched.filter((route) => route.meta.label)
      }
    }
  }
</script>